import React from 'react';
import { Row, Col } from 'antd'
import ImageCarousel from './ImageCarousel';
import TNContent from './TNContent';

const CollectionList = () => {
  return (
<TNContent maxWidth={1920} color="#FFF0D2">
<Row style={{ backgroundColor: '#FFF0D2', padding: '2% 0 8% 0' }} gutter={[0, 36]}>
      <Col span={24}>
        <ImageCarousel
          options={{ direction: 'left', gradient: false, pauseOnHover: true, speed: 30 }}
          data={[
            './assets/nft_1.png',
            './assets/nft_2.png',
            './assets/nft_3.png',
            './assets/nft_4.png',
            './assets/nft_5.png',
            './assets/nft_6.png',
            './assets/nft_7.png',
            './assets/nft_8.png',
            './assets/nft_9.png',
            './assets/nft_10.png',
          ]} />
      </Col>
      <Col span={24}>
        <ImageCarousel
          options={{ direction: 'right', gradient: false, pauseOnHover: true, speed: 30 }}
          data={[
            './assets/nft_11.png',
            './assets/nft_12.png',
            './assets/nft_13.png',
            './assets/nft_14.png',
            './assets/nft_15.png',
            './assets/nft_16.png',
            './assets/nft_17.png',
            './assets/nft_18.png',
            './assets/nft_19.png',
            './assets/nft_20.png',
          ]} />
      </Col>
    </Row>
</TNContent>
  )
}

export default CollectionList;